import {
  type ConnectRefusal,
  ConnectRefusalSchema,
} from "@vidimo/shared/contracts";
import { ApiRequestError } from "@/lib/api/api-error";

/**
 * Why the API refused a connect for good, when it said: a refusal no retry
 * clears, which the app answers with the Vidimo team rather than "try again".
 */
export function connectRefusalOf(error: unknown): ConnectRefusal | null {
  return error instanceof ApiRequestError
    ? connectRefusalFromText(error.detail)
    : null;
}

/** The same, from a response's raw text, before it becomes an error. */
export function connectRefusalFromText(text: string): ConnectRefusal | null {
  let body: unknown;
  try {
    body = JSON.parse(text);
  } catch {
    return null;
  }
  return connectRefusalFromBody(body);
}

/** The same, from an error body already read (the connect pages' own fetch). */
export function connectRefusalFromBody(body: unknown): ConnectRefusal | null {
  const refusal = ConnectRefusalSchema.safeParse(body);
  return refusal.success ? refusal.data : null;
}
